module.exports = __webpack_public_path__ + "img/IMG_6064.a85980bf.jpg";